import { createContainer } from '@dbk-legacy/muster/react';

import merge from 'lodash/merge';

import TransactionDetails from './transaction-details';

export const defaultRowFragment = {
  type: true,
  tradeNumber: true,
  valueDate: true,
  purchasePrice: true,
  currency: true,
  quantity: true,
  netAmount: true,
  tradeDate:true,
  posId:true,
  transactionDate:true,
  transactionNo:true,
};

export function factory({
  component = TransactionDetails,

  rowFragment = defaultRowFragment,
  rowFragmentExtend,
  } = {}) {
  let resultingRowFragment = rowFragment;

  if (rowFragmentExtend) {
    resultingRowFragment = merge({}, rowFragment, rowFragmentExtend);
  }

  return createContainer({
    $queries: {
      changePage: { $call: 'ui.history.push' },
      transact:{
        isEmpty: true,
        setIsEmpty: { $set: 'isEmpty' },
        getAdvices : { $call: 'getTransactionAdvices'},
      },
      i18n: {
       messages: true,
      },
    },
    $fragments: {
      uiStatic: {
        options: true,
        detailsGroups: true,
        labels: true,
      },
      row: resultingRowFragment,
    },
  }, ({ uiStatic, row, changePage, transact }) => {
    const { currency, ...rowRest } = row;
    const { options, ...uiStaticRest } = uiStatic;

    return {
      row: {
        purchasePriceUnit: currency,
        netAmountUnit: currency,
        ...rowRest,
      },
      headerGroup: options,
      ...uiStaticRest,
      changePage,
      transact,
    };
  })(component);
}

export default factory();
